<form
  class="flex flex-col items-center justify-center text-center"
  *ngIf="vm$ | async as vm">
  <div class="counter-input-container flex flex-row">
    <button
      type="button"
      class="minus-plus-container minus-button focus-link"
      (click)="subtractCounterValue.next()"
      [attr.aria-disabled]="vm.isMinusButtonDisabled"
      [attr.aria-label]="translationsConfig?.minusButtonAriaLabel">
      <rd-shared-icon
        class="minus-plus-icon minus-icon"
        [iconSymbol]="'icon-minus'"
        [iconTheme]="vm.minusIconTheme"
        [ngClass]="vm.minusIconActiveClass">
      </rd-shared-icon>
    </button>

    <mat-form-field
      class="mat-field"
      color="accent"
      aria-live="polite"
      aria-atomic="true"
      [attr.aria-label]="vm.ariaInputLabel">
      <input
        matInput
        counterNumberFormatter
        [debounceTime]="config.debounceTime!"
        [min]="config.minValue"
        [max]="config.maxValue"
        [shouldFormatValue]="config.formatValue"
        [step]="config.valuePerChange"
        [currentValue]="vm.counterValue"
        [disabled]="vm.isDisabled"
        (valueChange)="onCounterValueChange($event)"
        name="counter-input"
        type="text"
        aria-hidden="true"
        class="form-builder-input" />
    </mat-form-field>

    <button
      type="button"
      class="minus-plus-container plus-button focus-link"
      (click)="addCounterValue.next()"
      [attr.aria-disabled]="vm.isPlusButtonDisabled"
      [attr.aria-label]="translationsConfig?.plusButtonAriaLabel">
      <rd-shared-icon
        class="minus-plus-icon plus-icon"
        [iconSymbol]="'icon-plus'"
        [iconTheme]="vm.plusIconTheme"
        [ngClass]="vm.plusIconActiveClass">
      </rd-shared-icon>
    </button>
  </div>

  <mat-hint
    class="hint mt-1"
    [innerHTML]="translationsConfig?.hintTranslation"></mat-hint>

  <ng-content select="[errorCases]"></ng-content>
</form>
